// Pure helpers for the ops photo uploader (kept out of the component so
// they can be unit-tested without pulling in the API client).

const EXTS = /\.(jpe?g|png)$/i;

/** SCRUM-418: a folder copied off an SD card by a Mac carries a 4 KB
 * AppleDouble sidecar (`._DSC00001.jpg`) next to every photo; 1,123 of
 * them once went through the uploader into the Pearland event. Dotfiles
 * and non-image extensions never enter the queue. Judged on the file's
 * own name — the folder it sits in is irrelevant. */
export const isPhotoFile = (name) => {
  const file = (name || '').split('/').pop();
  return !file.startsWith('.') && EXTS.test(file);
};

/** Name the FTP server will record as Photos.originalFilename. */
export const remoteName = (prefix, name) => {
  const p = (prefix || '').replace(/[^A-Za-z0-9_-]/g, '');
  return p ? `${p}-${name}` : name;
};
